<template>
  <div>
    <el-upload action=""
               list-type="picture-card"
               :http-request="uploadHttp"
               :on-preview="handlePictureCardPreview"
               :fileList="fileList"
               :on-remove="handleRemove"
               :before-upload="beforeUpload">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import uploadMixin from './mixin'
export default {
  mixins: [uploadMixin],
  props: {
    // fileList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   },
    // },
    value: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
  data () {
    return {
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        if (value) {
          this.fileList = value.map(i => ({ name: '', url: i }));
        } else {
          this.fileList = [];
        }
      }
    },
  },
  methods: {
    addUrl (url) {
      this.$emit('input', this.value.concat(url))
    },
    handleRemove (file, fileList) {
      this.$emit('input', this.value.filter(i => i !== file.url));
      // this.$emit('removePicture', file.url)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  },
}
</script>
